import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../../shared/directives/directives.module';

import { AuthComponent } from './auth.component';
import { LoginComponent } from './components/login/login.component';
import { CadastroComponent } from './components/cadastro/cadastro.component';
import { CriarSenhaComponent } from './components/criar-senha/criar-senha.component';
import { RecuperarSenhaComponent } from './components/recuperar-senha/recuperar-senha.component';
import { ConfirmarEmailComponent } from './components/confirmar-email/confirmar-email.component';
import { RedefinirSenhaComponent } from './components/redefinir-senha/redefinir-senha.component';
import { EmailConfirmadoComponent } from './components/email-confirmado/email-confirmado.component';

import { LoginService } from './../../shared/services/auth/login/login.service';
import { CadastroService } from './../../shared/services/auth/cadastro/cadastro.service';
import { CriarSenhaService } from '../../shared/services/auth/criar-senha/criar-senha.service';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';
import { RecuperarSenhaService } from './../../shared/services/auth/recuperar-senha/recuperar-senha.service';
import { ErrorReportingService } from '../../shared/services/error-reporting/error-reporting.service';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { EmailConfirmationComponent } from './components/email-confirmation/email-confirmation.component';
import { RegisterPasswordComponent } from './components/register-password/register-password.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    DirectivesModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    NgxMaskDirective,
  ],
  declarations: [
    AuthComponent,
    LoginComponent,
    CadastroComponent,
    CriarSenhaComponent,
    RecuperarSenhaComponent,
    ConfirmarEmailComponent,
    RedefinirSenhaComponent,
    EmailConfirmadoComponent,
    EmailConfirmationComponent,
    RegisterPasswordComponent
  ],
  providers: [
    LoginService,
    CadastroService,
    CriarSenhaService,
    LocalStorageService,
    RecuperarSenhaService,
    ErrorReportingService,
    provideNgxMask()
  ],
})
export class AuthModule { }
